import { useQuery } from "@tanstack/react-query";
import { getPropertyContractsForDocumentsTab } from "../api/contracts";
import { ContractListItem } from "../dtos/contracts/index";
import { PROPERTY_TRACKS } from "../utils";

const useTrackContracts = ({
  propertyUid,
  type,
}: {
  propertyUid: string;
  type?: PROPERTY_TRACKS;
}) => {
  const contractsQuery = useQuery({
    queryKey: ["property-contracts-documents-list", propertyUid, type],
    queryFn: () => getPropertyContractsForDocumentsTab({ propertyUid, type }),
    enabled: !!propertyUid,
  });

  return {
    data: (contractsQuery.data?.data ?? []) as ContractListItem[],
    isLoading: contractsQuery.isLoading,
    isError: contractsQuery.isError,
  };
};

export default useTrackContracts;
